import { useState } from 'react';

import { Button, Image, Stack, Text, TextInput, Title } from '@mantine/core';

import { LogoPaper, TitleText } from '@/components';
import classes from './Login.module.css';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    // Redirect to external login microservice with email as query parameter
    const loginUrl = import.meta.env.VITE_LOGIN_URL;

    const trimmedEmail = email.trim();
    if (loginUrl && trimmedEmail) {
      const url = new URL(loginUrl);
      url.searchParams.set('email', trimmedEmail);
      url.searchParams.set('referer', `${window.location.origin}`);
      window.location.href = url.toString();
    } else {
      setIsLoading(false);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.leftSection}>
        <div className={classes.loginBox}>
          <Image
            src="/assets/gti/logo-primary-dark.svg"
            alt="Ground Truth Intelligence"
            className={classes.mobileLogo}
            mb="xl"
          />
          <Title order={2} className={classes.loginTitle}>
            Welcome Back
          </Title>
          <Text ta="center" c="var(--mantine-color-pastelBlue-2)" fw={600} mb="md">
            Enter your email to continue
          </Text>

          <LogoPaper>
            <form onSubmit={handleSubmit}>
              <Stack>
                <TextInput
                  label="Email Address"
                  placeholder="Enter your email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.currentTarget.value)}
                  disabled={isLoading}
                  size="md"
                />

                <Button
                  type="submit"
                  fullWidth
                  mt="xl"
                  loading={isLoading}
                  className={classes.submitButton}
                  size="lg"
                >
                  Sign In to Your Account
                </Button>
              </Stack>
            </form>
          </LogoPaper>
        </div>
      </div>

      <div className={classes.rightSection}>
        <Image
          src="/assets/gti/home-hero-image.png"
          alt="Ground Truth Intelligence"
          className={classes.heroImage}
        />
        <div className={classes.rightContent}>
          <LogoPaper>
            <TitleText />
          </LogoPaper>
        </div>
      </div>
    </div>
  );
}
